import dayjs from "dayjs";
import * as Yup from "yup";

export const HOLIDAY_PAGE = {
  HOLIDAY: "holiday",
  EMPLOYEE: "employee"
}
export const initialValues = {
  calendarName: "",
  calendarNameEn: "",
};

export const initialHolidayValues = {
  holidayCalendarGroupId: [],
  holidayName: "",
  holidayNameEn: "",
  date: dayjs(),
  statusFlag: "ACTIVE",
  year: dayjs().year(),
  holidayType: "company_holiday",
}

export const HolidaySchema = Yup.object().shape({
  holidayName: Yup.string().required("Please enter."),
  holidayNameEn: Yup.string().required("Please enter."),
  date: Yup.string().required("Please select date."),
  holidayType: Yup.string().required("Please select."),
});


export const CalendarSchema = Yup.object().shape({
  calendarName: Yup.string().required("Please enter."),
  calendarNameEn: Yup.string().required("Please enter."),
});
